import React from 'react';

/**
 * Displays the shipping method name and shippingCharge.
 *
 * @param props.shippingMethod The shipping method text
 * @param props.shippingCharge A map with key = shipping method text and value = shippingCharge
 * @param props.loading A flag indicating if the shipping charge is still being fetched
 */
export const ShippingMethodPrice = ({ shippingMethod, shippingCharge, loading }) => {
	if (!shippingMethod) {
		return null;
	}

	if (loading) {
		return (
			<span>
				{shippingMethod} <i className="fa fa-spinner fa-spin fa-fw"></i>
			</span>
		);
	} else if (shippingCharge || shippingCharge === 0) {
		return (
			<span>
				{shippingMethod} - $<span style={{ minWidth: '2ch', display: 'inline-block' }}>{shippingCharge}</span>
			</span>
		);
	} else {
		return (
			<span>
				{shippingMethod} <i className="text-danger fa fa-warning fa-fw"></i>
				<span className="text-danger small">
					{' '}
					An unexpected error occurred while loading the shipping charges.
				</span>
			</span>
		);
	}
};
